import { Link } from "react-router-dom";

export default function ApproacheSection() {
  return (
    <section className="py-24 bg-[#f8f9fb]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Text */}
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full border border-[#0A2540]/20 text-[#0A2540] text-xs uppercase tracking-widest mb-6">
              Notre Approche
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0A2540] leading-tight mb-6">
              Chaque mission réalisée avec sérieux
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-8">
              Afin d&apos;apporter des solutions concrètes et adaptées aux besoins du client. Chaque accompagnement est personnalisé, avec une écoute attentive et une analyse rigoureuse de votre situation.
            </p>
            <ul className="flex flex-col gap-4 mb-10">
              {[
                "Écoute et analyse approfondie de votre situation",
                "Solutions concrètes et personnalisées",
                "Suivi et accompagnement dans la durée",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-600 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-check-line text-[#0A2540] font-bold"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/a-propos"
              className="inline-flex items-center gap-2 text-[#0A2540] font-semibold text-sm hover:gap-3 transition-all duration-200 whitespace-nowrap"
            >
              En savoir plus sur BOBROWSKA
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          {/* Image */}
          <div className="flex-1 w-full">
            <div className="rounded-2xl overflow-hidden w-full h-[420px] md:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/3422147d5239b0e09c4a38a7da37a198.jpg"
                alt="Approche conseil BOBROWSKA"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
